import { isNull, isPlainObject, isUndefined, omitBy } from "lodash";
import moment from "moment";
import { SuperAgentRequest } from "superagent";
import { reduceObject } from "../../utils/utils";

export const serializeField = (x: any) => {
  if (x instanceof Date) return moment(x).format("yyyy-MM-DD");
  if (x instanceof Object) return JSON.stringify(x);
  return x;
};

export function flattenObj<T extends Object>(
  data: T,
  squareBrackets?: boolean
) {
  var result: Record<string, any> = {};
  if (Object.keys(data).length < 1) return result;

  function recurse(cur: Record<string, any> | Array<any>, prop: string) {
    if (Array.isArray(cur)) {
      for (var i = 0, l = cur.length; i < l; i++)
        recurse(
          cur[i],
          prop ? (squareBrackets ? `${prop}[${i}]` : prop + "." + i) : "" + i
        );
      if (l === 0) result[prop] = [];
    } else if (isPlainObject(cur)) {
      var isEmpty = true;
      for (var p in cur) {
        isEmpty = false;
        recurse(cur[p], prop ? prop + "." + p : p);
      }
      if (isEmpty) result[prop] = {};
    } else {
      result[prop] = cur;
    }
  }
  recurse(data, "");
  return result;
}

export function compactObj<B extends any, T extends Record<PropertyKey, B>>(
  obj: T
): Partial<T> {
  // TODO fix typing
  return reduceObject(
    obj,
    (acc, val, key) => (val === undefined ? acc : { ...acc, [key]: val }),
    {}
  );
}

export function addFieldsToForm<T extends Record<PropertyKey, any>>(
  req: SuperAgentRequest,
  fields: T
): SuperAgentRequest {
  return reduceObject(
    omitBy(fields, (x) => isNull(x) || isUndefined(x)),
    (acc, value, key) => {
      if (value instanceof FileList) {
        return acc.attach(key as any, value.item(0) as any);
      }
      if (
        (Array.isArray(value) &&
          value.length > 0 &&
          value[0] instanceof File) ||
        value instanceof File
      ) {
        return acc.attach(key as any, value as any);
      }
      return acc.field(key as any, serializeField(value) as any);
    },
    req
  );
}
